import http from "../utils/request";
import type { EntityId } from "../types/shopGoods";
import type { ShopResponse } from "../types/shopMerchant";
import type { CatalogKind, CatalogRecord, CatalogWrite } from "../types/shopCatalog";

export function listCatalog(kind: CatalogKind, specId?: EntityId, signal?: AbortSignal): Promise<ShopResponse<CatalogRecord[]>> {
  if (kind === "specValue") {
    return http.get<never, ShopResponse<CatalogRecord[]>>("/shop/specValue/list", { params: { specId }, signal });
  }
  return http.post<never, ShopResponse<CatalogRecord[]>>(`/shop/${kind}/list`, {}, { signal });
}
export function saveCatalog(kind: CatalogKind, data: CatalogWrite): Promise<ShopResponse<unknown>> {
  return http.post<never, ShopResponse<unknown>>(`/shop/${kind}/${data.id == null ? "add" : "edit"}`, data);
}
export function batchAddCatalog(kind: CatalogKind, data: CatalogWrite[]): Promise<ShopResponse<unknown>> {
  return http.post<never, ShopResponse<unknown>>(`/shop/${kind}/batchAdd`, data);
}
export function deleteCatalog(kind: CatalogKind, ids: EntityId[]): Promise<ShopResponse<unknown>> {
  if (!ids.length) return Promise.reject(new Error("请选择要删除的数据"));
  return ids.length === 1
    ? http.post<never, ShopResponse<unknown>>(`/shop/${kind}/delete/${ids[0]}`, {})
    : http.post<never, ShopResponse<unknown>>(`/shop/${kind}/batchDelete`, ids);
}
